import app from 'flarum/app';
import LinkButton from 'flarum/components/LinkButton';
import FieldList from '../fields/FieldList';
import ValueHistory from '../utils/ValueHistory';
import AbstractFormPage from './AbstractFormPage';
import SaveControls from '../components/SaveControls';
import FormTitle from '../components/FormTitle';
import PageContainer from '../components/PageContainer';
import Uploader from '../utils/Uploader';

/* global m */

const translationPrefix = 'kilowhat-formulaire.forum.submission.';

export default class FormShowPage extends AbstractFormPage {
    show(form) {
        super.show(form);

        this.history = new ValueHistory({});
        this.submission = null; // Set once the form has been submitted
        this.uploader = new Uploader(form);
    }

    content() {
        // TODO: show form for previews even if cannot submit
        if (!this.form.attribute('canSubmit')) {
            return PageContainer.component({
                showSideNav: app.forum.attribute('formulaireShowSideNavOnSubmission'),
                narrow: true,
                noTheme: true,
            }, [
                m(FormTitle, {
                    form: this.form,
                }),
                m('p', app.translator.trans(translationPrefix + (this.form.attribute('isFull') ? 'form-full' : 'form-closed'))),
            ]);
        }

        if (this.submission) {
            const message = this.form.confirmationMessageHtml();
            return PageContainer.component({
                showSideNav: app.forum.attribute('formulaireShowSideNavOnSubmission'),
                narrow: true,
                noTheme: true,
            }, [
                m(FormTitle, {
                    form: this.form,
                }),
                message ? m('div', m.trust(message)) : m('p', app.translator.trans(translationPrefix + 'submitted-successfully')),
                this.submission.attribute('canEdit') ? LinkButton.component({
                    className: 'Button',
                    href: app.route.formulaireSubmission(this.submission),
                }, app.translator.trans(translationPrefix + 'edit-submission')) : null,
                LinkButton.component({
                    className: 'Button',
                    href: app.route.formulaireFormShow(this.form),
                }, app.translator.trans(translationPrefix + 'submit-other')),
            ]);
        }

        const list = new FieldList({
            configs: this.form.template(),
            submission: this.history.value,
            uploader: this.uploader,
            onchange: () => {
                this.history.save();
                this.dirty = true;
            },
            disabled: this.loading || this.uploader.uploading,
            validationErrors: this.validationErrors,
        });

        return PageContainer.component({
            showSideNav: app.forum.attribute('formulaireShowSideNavOnSubmission'),
            narrow: true,
            noTheme: true,
        }, [
            m(FormTitle, {
                form: this.form,
            }),
            list.listView(),
            SaveControls.component({
                dirty: this.dirty,
                loading: this.loading,
                savedAt: this.savedAt,
                inError: Object.keys(this.validationErrors).length,
                history: app.forum.attribute('formulaireShowHistoryControls') ? this.history : null,
                onsave: () => {
                    this.loading = true;

                    app.request({
                        method: 'POST',
                        url: app.forum.attribute('apiUrl') + this.form.apiEndpoint() + '/submissions',
                        data: {
                            data: {
                                attributes: {
                                    data: this.history.value,
                                },
                            },
                        },
                        errorHandler: this.onerror.bind(this),
                    }).then(data => {
                        this.submission = app.store.pushPayload(data);
                        this.loading = false;
                        this.dirty = false;
                        this.savedAt = new Date();
                        this.validationErrors = {};
                        this.history.clear();
                        m.redraw();
                    }).catch(error => {
                        this.loading = false;
                        m.redraw();
                        throw error;
                    });
                },
            }),
        ]);
    }
}
